import "core-js/modules/es.array.concat.js";
import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { jsx as _jsx } from "react/jsx-runtime";

var _templateObject;

import React from 'react';
import styled from 'styled-components';

var hContainer = function hContainer(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(props.className, " ").concat(props.custom ? 'trakr__h-container' : ''),
    children: props.children
  });
};

export var ContainerHorizontal = styled(hContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n  align-items: ", ";\n  height: ", ";\n  width: ", ";\n  max-width: ", ";\n"])), function (props) {
  return props.justify ? props.justify : 'center';
}, function (props) {
  return props.align ? props.align : 'center';
}, function (props) {
  return props.height ? props.height : props.fullHeight ? '100%' : 'inherit';
}, function (props) {
  return props.fullWidth ? '100%' : 'inherit';
}, function (props) {
  return props.maxWidth || 'none';
});